/** A source of uniform numbers in [0, 1). */
export type Rng = () => number;

/**
 * mulberry32: the reference RNG for Halvard. The same seed gives the same sequence on every
 * platform, which keeps generated mountains stable over time. Do not change this function.
 */
export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Integer in [0, n), drawn from `rng`. */
export function randomInt(rng: Rng, n: number): number {
  return Math.floor(rng() * n);
}
